module.exports = __webpack_public_path__ + "img/ding.b745a74b.png";